export default "__VITE_ASSET__ipb7d4KR__"